import { AddressFormsContext, BiContext, ConfigContextProvider, EventsProvider, ExperimentsContext, ExternalDataProvider, FieldInitialDataContext, FocusedFieldProvider, ForcedStateContext, FormContext, getAddressForm, PanoramaContext, ScrollProvider, TranslationContext, WixRicosViewerContext } from '@wix/form-fields';
import React, { useMemo } from 'react';
import { SubmitStatusProvider } from '../../contexts/submit-status-context';
import { useFormBi } from '../form/use-form-bi';
export const FormViewerProvider = ({ i18n, bi, biFormFillSessionId, form, isMobile, isEditor, isComposer, isRTL, compId, PortalContainer, language, regionalFormat, externalData, forcedState, children, panorama, experiments, translationNamespace, currency, userData, WixRicosViewer, addressTemplates, fieldInitialData, enableAnimations, cssMobileLayout, baseUrl })=>{
    const translations = useMemo(()=>({
            t: i18n.getFixedT(language, translationNamespace),
            i18n
        }), [
        language,
        i18n,
        translationNamespace
    ]);
    const formBi = useFormBi(form, bi, biFormFillSessionId);
    const defaultPortalContainer = useMemo(()=>compId ? ({ children: portalChildren })=>/*#__PURE__*/ React.createElement("div", {
                className: `${compId} ${compId}_ooi`,
                // no box = keeps the widget's CSS vars without inheriting its height and margins
                style: {
                    display: 'contents'
                }
            }, portalChildren) : undefined, [
        compId
    ]);
    const resolvedPortalContainer = PortalContainer ?? defaultPortalContainer;
    const config = useMemo(()=>({
            language,
            regionalFormat,
            isMobile,
            currency,
            userData,
            compId,
            PortalContainer: resolvedPortalContainer,
            baseUrl,
            isEditor,
            isComposer,
            isRTL,
            enableAnimations,
            cssMobileLayout
        }), [
        language,
        regionalFormat,
        isMobile,
        currency,
        userData,
        compId,
        resolvedPortalContainer,
        baseUrl,
        isEditor,
        isComposer,
        isRTL,
        enableAnimations,
        cssMobileLayout
    ]);
    const forcedViewState = useMemo(()=>forcedState ?? [], [
        forcedState
    ]);
    return /*#__PURE__*/ React.createElement(PanoramaContext.Provider, {
        value: {
            panorama
        }
    }, /*#__PURE__*/ React.createElement(TranslationContext.Provider, {
        value: translations
    }, /*#__PURE__*/ React.createElement(ScrollProvider, null, /*#__PURE__*/ React.createElement(FocusedFieldProvider, null, /*#__PURE__*/ React.createElement(FieldInitialDataContext.Provider, {
        value: fieldInitialData
    }, /*#__PURE__*/ React.createElement(BiContext.Provider, {
        value: formBi
    }, /*#__PURE__*/ React.createElement(ExternalDataProvider, {
        externalData: externalData
    }, /*#__PURE__*/ React.createElement(ConfigContextProvider, {
        value: config
    }, /*#__PURE__*/ React.createElement(ForcedStateContext.Provider, {
        value: forcedViewState
    }, /*#__PURE__*/ React.createElement(FormContext.Provider, {
        value: form
    }, /*#__PURE__*/ React.createElement(AddressFormsContext.Provider, {
        value: {
            getCountryAddressForm: (country)=>getAddressForm(addressTemplates, country),
            addressTemplates
        }
    }, /*#__PURE__*/ React.createElement(ExperimentsContext.Provider, {
        value: experiments
    }, /*#__PURE__*/ React.createElement(EventsProvider, null, /*#__PURE__*/ React.createElement(WixRicosViewerContext.Provider, {
        value: WixRicosViewer
    }, /*#__PURE__*/ React.createElement(SubmitStatusProvider, null, children)))))))))))))));
};

//# sourceMappingURL=form-viewer-provider.js.map